import React, { useState } from 'react';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import {CxIcon} from "./CxIcon";

// --------------------------------------------------------------------------------------------------------------------
// Settings
// --------------------------------------------------------------------------------------------------------------------

const sxMenuLabel = {
    textTransform: 'none',                                      // keep text from becoming uppercase
    fontSize: '1rem',                                           // same font size as MenuItem (default body1)
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',         // default font family
    fontWeight: 400
}

// --------------------------------------------------------------------------------------------------------------------
// CxMenuButton
// --------------------------------------------------------------------------------------------------------------------


export function CxMenuButton({ label, iconName, actionName, callback, ...props }) {
    const hasLabel = Boolean(label);

    const renderButton= () => {
        return (
            <IconButton
                edge="start"
                color="inherit"
                aria-label={iconName}
                onClick={() => callback(actionName)}
                sx={sxMenuLabel}
                {...props}>
                <CxIcon name={iconName} />
            </IconButton>
        )
    }

    const renderLabelButton = () => {
        return (
            <Button color="inherit"
                    onClick={() => callback(actionName)}
                    startIcon={ <CxIcon name={iconName} /> }
                    sx={sxMenuLabel}
                    {...props}>
                {label}
            </Button>
        )
    }

    return hasLabel ? renderLabelButton() : renderButton();
}

// --------------------------------------------------------------------------------------------------------------------
// CxMenuItem
// --------------------------------------------------------------------------------------------------------------------

export function CxMenuItem({label, iconName, actionName, callback}) {

    const renderMenuItem = () => {
        return (
            <MenuItem onClick={() => callback(actionName)} disableRipple={true}>
                <CxIcon name={iconName} sx={{mr: 1}} />
                {label}
            </MenuItem>
        )
    }

    return renderMenuItem();
}


// --------------------------------------------------------------------------------------------------------------------
// CxMenuBox
// --------------------------------------------------------------------------------------------------------------------

export function CxMenuBox({ label, iconName, callback, menuItems }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);

    const handleMenuClose = (actionName) => {
        setAnchorEl(null);
        if (callback && actionName) {
            callback(actionName);
        }
    };

    return (
        <>
            <MenuItem color="inherit" onClick={handleMenuOpen} disableRipple>
                <CxIcon name={iconName} sx={{mr: 1}} />
                {label}&nbsp;{"\u25BC"}
            </MenuItem>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleMenuClose()}>
                {menuItems.map((item, index) => (

                    <MenuItem key={index} onClick={() => handleMenuClose(item.actionName)} disableRipple>
                        <ListItemIcon>
                            <CxIcon name={item.iconName}/>
                        </ListItemIcon>
                        <ListItemText>{item.label}</ListItemText>
                    </MenuItem>

                ))}
            </Menu>
        </>
    );
}





